import { render, staticRenderFns } from "./customerList.vue?vue&type=template&id=73d3429e&scoped=true&"
import script from "./customerList.vue?vue&type=script&lang=js&"
export * from "./customerList.vue?vue&type=script&lang=js&"
import style0 from "./customerList.vue?vue&type=style&index=0&id=73d3429e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d3429e",
  null
  
)

export default component.exports